import { z } from "zod";

export const couponFormSchema = z.object({
	couponCode : z
		.string()
		.min(1, { message : "Musíte vyplnit kód kupónu." })
});